import React, { useMemo, useEffect, useState, createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useScrollTop } from 'Hooks/useScrollTop';
import { useEmailCoupon } from 'Hooks/useEmailCoupon';
import Header from 'Layouts/Header';
import { Footer } from 'Layouts/Footers';
import { HeaderTitle } from 'Components/HeaderTitle/HeaderTitle';
import { ErrorBoundary } from 'Components/ErrorBoundary/ErrorBoundary';
import { identify, loadTealium } from 'Utils/Analytics';
import { heapIdentify } from 'Utils/Analytics/Heap';
import { useLocation } from 'react-router-dom';
import './AppLayout.css';

const LayoutContext = createContext();
export const useLayoutsActions = () => useContext(LayoutContext);

const locationBasedClasses = {
  '/': 'landing',
  '/account/signup-confirmation': 'confirmed',
  '/signup-confirmation': 'confirmed',
  '/account/redeem': 'giftingHome',
  '/account/redeem/': 'giftingHome',
  '/account/review-and-redeem': 'giftingRedeem centerFrame',
};

export const getDefaultClassNames = (pathname) => {
  return `defaultLayout ${locationBasedClasses[pathname] || 'centerFrame'}`;
};

export default function AppLayout({ children }) {
  const [showLayout, setLayout] = useState(true);
  const { pathname = '' } = useLocation();
  const { tealiumProductEnv } = useSelector((s) => s.appConfig.defaultConfig);

  // call segment identify api
  useEffect(() => {
    identify();
  }, []);

  // load tealium script
  useEffect(() => {
    loadTealium(tealiumProductEnv);
  }, [tealiumProductEnv]);

  // call Heap identity
  const ajsUserId = useMemo(() => {
    const storedUserId = localStorage.getItem('ajs_user_id');
    return storedUserId && storedUserId;
  }, []);

  useEffect(() => {
    heapIdentify(ajsUserId);
  }, [ajsUserId]);

  useScrollTop();
  useEmailCoupon();

  const layoutClassName = useMemo(() => getDefaultClassNames(pathname), [pathname]);

  return (
    <ErrorBoundary name="app layout">
      <LayoutContext.Provider value={setLayout}>
        <div className={`fn-app ${layoutClassName}`}>
          <HeaderTitle path={pathname} />
          {showLayout && (
            <div className="headerContainer sticky">
              <Header />
            </div>
          )}
          <div className="bodyContainer" role="main">
            {children}
          </div>
          {showLayout && <Footer path={pathname} />}
        </div>
      </LayoutContext.Provider>
    </ErrorBoundary>
  );
}
